import React from 'react';
import { Globe2Icon, InstagramIcon, MailIcon } from 'lucide-react';
const links = [{
  icon: MailIcon,
  label: 'Email support',
  href: 'mailto:support.peready360@gmail.com'
}, {
  icon: InstagramIcon,
  label: 'Follow on Instagram',
  href: 'https://instagram.com/peready360'
}, {
  icon: Globe2Icon,
  label: 'Official site',
  href: 'https://www.peready360.com'
}];
export function Footer() {
  return <footer className="bg-stone-100 px-5 py-14 text-center" data-id="element-62" data-mp="3uftlpmn2lrzt">
      <div className="mx-auto max-w-4xl" data-id="element-63" data-mp="38zawx2kd95j">
        <p className="font-display text-3xl font-semibold uppercase tracking-[.06em] text-ink-900" data-id="element-64" data-mp="36mu4n8jl4u2">
          Functional Ready™
        </p>
        <p className="mt-3 text-sm font-semibold text-ink-800" data-id="element-65" data-mp="3qcxawi3rv06f">
          The complete teaching toolkit for functional training coaches.
        </p>
        <p className="mx-auto mt-2 max-w-md font-display text-lg italic text-ink-600" data-id="element-66" data-mp="29xvpe8qab5n7">
          Because coaching shouldn’t cost you every evening of the week.
        </p>
        <div className="mx-auto mt-8 flex max-w-xl flex-wrap justify-center gap-x-6 gap-y-3 border-y border-line py-6 text-sm font-medium text-ink-600" data-id="element-67" data-mp="3lalf9cv8a1sw">
          {links.map(({
          icon: Icon,
          label,
          href
        }) => <a key={label} className="flex items-center gap-2 transition-colors duration-150 ease-out hover:text-ink-900" href={href} data-id="element-68" data-mp="3v8htidjgpcv8">
              <Icon className="h-4 w-4 text-sage-600" data-id="element-69" data-mp="81pghm1kl3ay" />
              {label}
            </a>)}
        </div>
        <p className="mt-8 text-[10px] font-semibold uppercase tracking-[.18em] text-stone-500" data-id="element-70" data-mp="33e3x3jw4ep1">
          Functional Ready™ — Professional Education · © 2026 — All rights
          reserved.
        </p>
      </div>
    </footer>;
}